import { render, staticRenderFns } from "./novahome.vue?vue&type=template&id=68953240&scoped=true&"
import script from "./novahome.vue?vue&type=script&lang=js&"
export * from "./novahome.vue?vue&type=script&lang=js&"
import style0 from "./novahome.vue?vue&type=style&index=0&id=68953240&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68953240",
  null
  
)

export default component.exports